import {Alert, Box} from '@mui/material';
import {TFunction} from 'i18next';

export default function MutationStatusIndicator({
  mutationStatus,
  error,
  t
}: {
  mutationStatus: 'error' | 'idle' | 'loading' | 'success';
  error: string;
  t: TFunction;
}) {
  if (mutationStatus !== 'error') {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        mt: 1
      }}
    >
      <Alert sx={{width: '100%'}} severity="error">
        {error === 'isDermatologyDomain' ||
          (error.startsWith('Image is not dermatological') &&
            t('ui:diagnosticReport.imageError.cardSubheaderHeader.isDermatological'))}
        {error === 'qualityAcceptable' ||
          (error.startsWith('Image quality is not acceptable') &&
            t('ui:diagnosticReport.imageError.cardSubheaderHeader.qualityAcceptable'))}
        {error === 'invalidPose' &&
          t('ui:diagnosticReport.imageError.cardSubheaderHeader.invalidPose')}
      </Alert>
    </Box>
  );
}
